import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusConversion',
})
export class StatusConversionPipe implements PipeTransform {

  transform(value:any): any {

    switch (value){
      case '1040':
        return 'Draft Sent'
        break;
      case '1039':
        return 'Completed'
        break;
      case '1038':
        return 'In Progress'
        break;
      case '1037':
        return 'Scheduled'
        break;
      case '1036':
        return 'Yet To Schedule'
        break;
      case '1041':
        return 'Approved'
        break;
      default:
        return ''         
    }
  }

}
